// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ColorStyling.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * ColorStyling Component
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ColorPicker from './Izenda.ColorPicker';
import { isNil } from 'lodash/fp';
import localizer from 'share/localization/Izenda.Localizer';
import UIConstants from 'logic/data/Izenda.UIConstants';

export default class ColorStyling extends Component {
  static propTypes = {
    value: PropTypes.object,
    options: PropTypes.object,
    type: PropTypes.string,
    onChangeColor: PropTypes.func,
    disabled: PropTypes.bool
  };

  static defaultProps = {
    value: {
      textColor: UIConstants.textColor,
      backgroundColor: UIConstants.backgroundColor,
      alpha :UIConstants.alpha,
      isAlpha:UIConstants.isAlpha
    },
    options: {
      text: true,
      background: true
    }
  };

  constructor(props: string) {
    super(props);
    const value = this.props.value || {};

    this.state = {
      textColor: value.textColor,
      backgroundColor: value.backgroundColor,
      alpha: value.alpha,
      isAlpha: value.isAlpha
    };
  }

  componentWillReceiveProps(nextProps: any) {
    const value = nextProps.value || {};

    this.setState({
      textColor: value.textColor,
      backgroundColor: value.backgroundColor,
      alpha: value.alpha
    });
  }

  renderColorPicker = (color: string, type: string, iconName: string, title: string,alpha) => {
    const props = this.props;

    const onChangeColor = (color,alpha) => {
      let newValue = {};
      newValue[type] = color;
      newValue.alpha = alpha;
      this.setState(newValue, () => {
        props.onChange && props.onChange({ value: this.state }, { keyChange: type });
      });
    };

    const isAlpha = type === UIConstants.COLOR_TYPE.BACKGROUND_COLOR && this.state.isAlpha || false;

    return (
      <ColorPicker
        color={color}
        disabled={props.disabled}
        iconName={iconName}
        type={props.type}
        position={props.position}
        onChange={onChangeColor}
        title={title}
        alpha = {alpha}
        isAlpha = {isAlpha}
      />
    );
  }

  render() {
    const state = this.state;
    const { options, className } = this.props;

    return (
      <div className={className}>
        {!isNil(options.text) &&
          this.renderColorPicker(
            state.textColor,
            'textColor',
            'icon-font',
            localizer.getText('COLOR_STYLING_TEXT_TOOLTIP'),
            state.alpha
          )
        }
        {!isNil(options.background) &&
          this.renderColorPicker(
            state.backgroundColor,
            'backgroundColor',
            'icon-tint',
            localizer.getText('COLOR_STYLING_BACKGROUND_TOOLTIP'),
            state.alpha
          )
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.ColorStyling.jsx